import React, { useEffect } from "react";
import HelmetReact from "../../Components/Helmet";
import {
  Box,
  FormControl,
  Grid,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";

import LineChart from "../../Components/Chart";

import { saveAs } from "file-saver";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import {
  getPractitionerDetailChart,
  getProgramChartData,
} from "../../Redux/Actions/OverviewAction";

const Overview = () => {
  const dispatch = useDispatch();
  const { OverviewList, PractitionerOverview } = useSelector(
    (state) => state?.Overview
  );
  const { user } = useSelector((state) => state.Auth);

  const handleChange = (e) => {
    let payload = e.target.value;
    if (user?.role === "doctor") {
      const payload = {
        Id: user?.id,
        Month: e.target.value,
      };
      dispatch(getPractitionerDetailChart(payload));
    }
    dispatch(getProgramChartData(payload));
  };

  useEffect(() => {
    dispatch(getProgramChartData(6));
  }, [dispatch]);

  useEffect(() => {
    if (user?.role === "doctor") {
      let payload = {
        Id: user?.id,
        Month: 6,
      };
      dispatch(getPractitionerDetailChart(payload));
    }
  }, [user.role, dispatch]);
  const labels =
    OverviewList?.program?.length &&
    OverviewList?.program?.map((value) => value?.program);
  const role = user?.role;
  const practitionerOverviewLabels =
    PractitionerOverview?.programList?.length &&
    PractitionerOverview?.programList?.map((value) => value.program);

  const data = {
    labels: role === "doctor" ? practitionerOverviewLabels : labels,
    datasets: [
      {
        label: "Program",
        data:
          role === "doctor"
            ? PractitionerOverview?.programList?.length &&
              PractitionerOverview?.programList?.map((value) =>
                Math.ceil(value.value)
              )
            : OverviewList?.program?.length &&
              OverviewList?.program?.map((value) => value.value),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const labels2 =
    OverviewList?.active_user_doctor?.length &&
    OverviewList?.active_user_doctor?.map((value) => value?.month);
  const data2 = {
    labels: labels2,
    datasets: [
      {
        label: "Clients",
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value?.patient),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
      {
        label: "Practioners",
        data:
          OverviewList?.active_user_doctor?.length &&
          OverviewList?.active_user_doctor?.map((value) => value?.doctor),
        fill: true,
        backgroundColor: "rgba(198,151,245,0.5)",
        borderColor: "rgb(198, 151, 245)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const options = {
    type: "line",
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },
      title: {
        display: true,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        usePointStyle: false,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 4;

            if (labels?.length && labels?.length > 4) {
              if (labels[tick]?.length >= characterLimit) {
                return (
                  labels[tick]
                    ?.slice(0, labels[tick]?.length)
                    ?.substring(0, characterLimit - 1)
                    ?.trim() + ".."
                );
              }
            }
            return labels[tick];
          },
        },
      },
      y: {
        stacked: true,
        beginAtZero: true,
        ticks: {
          callback: (value) => {
            return value + " %";
          },
        },
      },
    },
  };
  const options2 = {
    type: "line",
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },
      title: {
        display: true,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        usePointStyle: false,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true, // Enable wheel zooming
          },
          mode: "x",
        },
      },
    },
    scales: {
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 4;

            if (labels2 && labels2?.length && labels2?.length > 4) {
              if (labels2[tick]?.length >= characterLimit) {
                return (
                  labels2[tick]
                    .slice(0, labels2[tick]?.length)
                    .substring(0, characterLimit - 1)
                    .trim() + ".."
                );
              }
            }
            return labels2[tick];
          },
        },
      },
      y: {
        beginAtZero: true,
      },
    },
  };
  // const data3 = {
  //   labels: labels2,
  //   datasets: [
  //     {
  //       label: "LOAD TIMES",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.patient),
  //       fill: true,
  //       backgroundColor: "rgba(155,230,249,0.5)",
  //       borderColor: "rgb(155,230,249)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //     {
  //       label: "CRASH  RATE",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.doctor),
  //       fill: true,
  //       backgroundColor: "rgba(230,201,98,0.39)",
  //       borderColor: "rgb(232,189,36)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //     {
  //       label: "ERROR  RATE",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.doctor),
  //       fill: true,
  //       backgroundColor: "rgba(198,151,245,0.5)",
  //       borderColor: "rgb(198, 151, 245)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //   ],
  // };
  // const data4 = {
  //   labels: labels2,
  //   datasets: [
  //     {
  //       label: "INDIVIDUAL PLAN",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.patient),
  //       fill: true,
  //       backgroundColor: "rgba(155,230,249,0.5)",
  //       borderColor: "rgb(155,230,249)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //     {
  //       label: "COMPREHENSIVE PLAN",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.doctor),
  //       fill: true,
  //       backgroundColor: "rgba(230,201,98,0.39)",
  //       borderColor: "rgb(232,189,36)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //     {
  //       label: "ENTERPRISE PLAN",
  //       data:
  //         OverviewList?.active_user_doctor?.length &&
  //         OverviewList?.active_user_doctor?.map((value) => value?.doctor),
  //       fill: true,
  //       backgroundColor: "rgba(198,151,245,0.5)",
  //       borderColor: "rgb(198, 151, 245)",
  //       pointBackgroundColor: "white",
  //       pointStyle: "circle",
  //       borderWidth: 1,
  //       pointRadius: 5,
  //       pointHoverRadius: 7,
  //       tension: 0.4,
  //     },
  //   ],
  // };
  // const options3 = {
  //   type: "bar",
  //   responsive: true,
  //   maintainAspectRatio: true,
  //   plugins: {
  //     legend: {
  //       position: "bottom",
  //       align: "start",
  //       onClick: null,
  //     },
  //     title: {
  //       display: true,
  //     },
  //     interaction: {
  //       intersect: true,
  //     },
  //     tooltip: {
  //       usePointStyle: false,
  //     },
  //     zoom: {
  //       pan: {
  //         enabled: true,
  //         mode: "x",
  //       },
  //       zoom: {
  //         wheel: {
  //           enabled: true, // Enable wheel zooming
  //         },
  //         mode: "x",
  //       },
  //     },
  //   },
  //   scales: {
  //     x: {
  //       stacked: true,
  //       ticks: {
  //         callback: function (tick) {
  //           var characterLimit = 4;

  //           if (labels2 && labels2?.length && tick && labels2?.length > 4) {
  //             if (labels2[tick]?.length >= characterLimit) {
  //               return (
  //                 labels2[tick]
  //                   ?.slice(0, labels2[tick]?.length)
  //                   ?.substring(0, characterLimit - 1)
  //                   .trim() + ".."
  //               );
  //             }
  //           }
  //           return labels2[tick];
  //         },
  //       },
  //     },
  //     y: {
  //       stacked: true,
  //       beginAtZero: true,
  //     },
  //   },
  // };
  //style for pdf file
  const styles = StyleSheet.create({
    mainPage: {
      padding: "15px",
      fontSize: "12px",
      backgroundColor: "#f9f9f9",
      color: "grey",
    },

    divider: {
      borderBottom: "1px solid black",
      width: "25vw",
      marginTop: "10px",
    },
    DataContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "20px 0px",
    },
    DataContainerLabel: {
      flexDirection: "row",
    },
    ImageBox: {
      width: "400px",
      border: "1px solid black",
      borderRadius: "5px",
      padding: "5px",
      margin: "3px",
    },
    AlignLabel1: {
      fontSize: "11px",
      marginLeft: "10px",
    },
    AlignLabel2: {
      fontSize: "11px",
      marginLeft: "280px",
    },
    AlignLabel3: {
      fontSize: "11px",
      marginLeft: "10px",
    },
    AlignLabel4: {
      fontSize: "11px",
      marginLeft: "450px",
    },
    AlignLabel5: {
      fontSize: "11px",
      marginLeft: "10px",
    },
    AlignLabel6: {
      fontSize: "11px",
      marginLeft: "450px",
    },
  });
  let Arr1 = [];
  let Arr2 = [];

  Arr1 =
    OverviewList?.program?.length && OverviewList?.program?.map((item) => item);
  Arr2 =
    OverviewList?.active_user_doctor?.length &&
    OverviewList?.active_user_doctor?.map((item) => item);

  let data1 = [];

  for (let i = 0; i < Math?.max(Arr1?.length, Arr2?.length); i++) {
    data1.push({
      PROGRAM: Arr1[i]?.program,
      "COMPLETION-RATE": Arr1[i]?.value,
      MONTH: Arr2[i]?.month,
      DOCTOR: Arr2[i]?.doctor,
      PATIENT: Arr2[i]?.patient,
    });
  }
  //download csv file
  const formatDataToCSV = (data) => {
    const header = Object?.keys(data[0]).join(",");
    const rows = data?.map((item) => Object?.values(item).join(","));
    return `${header}\n${rows.join("\n")}`;
  };

  const downloadCSV = (csvData) => {
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "Overview.csv";
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCSV = async () => {
    const csvData = formatDataToCSV(data1);
    downloadCSV(csvData);
  };

  //download pdf file
  const generatePDF = async () => {
    const chartCanvas1 = await document.querySelector("#chart1");
    const chartCanvas2 = await document.querySelector("#chart2");
    const chartData1 = await chartCanvas1.toDataURL();
    const chartData2 = await chartCanvas2.toDataURL();

    const blob = await pdf(
      <Document>
        <Page style={styles.mainPage} wrap size="A4" orientation="landscape">
          <View>
            <View style={styles.DataContainer}>
              <Image src={chartData1} /> <Image src={chartData2} />
            </View>
            <View style={styles.DataContainerLabel}>
              <Text style={styles.AlignLabel1}>
                Program Completion Rate (%)
              </Text>
              <Text style={styles.AlignLabel2}>
                Active Users
              </Text>
            </View>
          </View>        
        </Page>
      </Document>
    ).toBlob();
    saveAs(blob, "Overview");
  };

  const handleChangeDownload = (e) => {
    switch (e.target.value) {
      case "csv":
        handleDownloadCSV()
        break
      case "pdf":
        generatePDF()
        break
      default:
        break
    }
    // e.target.value === "csv" ? handleDownloadCSV() : e.target.value === "pdf" ? generatePDF() : "";
  };

  return (
    <>
      <HelmetReact name="Overview" />
      <Box className="d-details-box">
        <Box
          sx={{
            // textAlign: "right",
            my: 2,
            display: "flex",
            justifyContent: "end",
            gap: "5px"
          }}
        >
          <FormControl>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              autoWidth
              defaultValue="Download"
              onChange={handleChangeDownload}
              sx={{ backgroundColor: "white" }}
            >
              <MenuItem disabled value={"Download"}>Download</MenuItem>
              <MenuItem value={"pdf"}>PDF</MenuItem>
              <MenuItem value={"csv"}>CSV</MenuItem>
            </Select>
          </FormControl>

          <FormControl>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              autoWidth
              defaultValue={6}
              onChange={handleChange}
              sx={{ backgroundColor: "white" }}
            >
              <MenuItem value={3}>Last 3 Months</MenuItem>
              <MenuItem value={6}>Last 6 Months</MenuItem>
              <MenuItem value={12}>1 Year</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box className="dDetails-img">
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                data={data}
                options={options}
                id="chart1"
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3 }}
              >
                Program Completion Rate (%)
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                data={data2}
                options={options2}
                id="chart2"
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3 }}
              >
                Active Users
              </Typography>
            </Grid>
          </Grid>
        </Box>
        {/* <Box className="dDetails-img">
            <Grid container spacing={2}>
              <Grid item lg={6} md={6} xs={12}>
                <LineChart
                  type="bar"
                  data={data3}
                  id="chart3"
                  options={options3}
                  className="chart-item"
                />
                <Typography
                  className="graph-desc"
                  variant="h6"
                  sx={{ color: "grey", my: 3 }}
                >
                  APP PERFOMANCE: APP LOAD TIMES, CRASH RATES, AND ERROR RATES
                </Typography>
              </Grid>
              <Grid item lg={6} md={6} xs={12}>
                <LineChart
                  data={data4}
                  type="bar"
                  id="chart4"
                  options={options3}
                  className="chart-item"
                />
                <Typography
                  className="graph-desc"
                  variant="h6"
                  sx={{ color: "grey", my: 3 }}
                >
                  REVENUE($): TOTAL AND CATEGORISED BY SUBSCRIPTION PLAN
                </Typography>
              </Grid>
            </Grid>
          </Box> */}
      </Box>
    </>
  );
};

export default Overview;
